import styles from './GlobalTimeRangeFilter.module.scss';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import {
  globalTimeRangeValues,
  GlobalTimeRange,
  setGlobalTimeFilter,
} from '@customer/store/slices/globalSlice';
import { useCallback, useMemo } from 'react';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { useTranslation } from 'react-i18next';
import Dropdown from '@cas/components/inputs/dropdown/Dropdown';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

const useTimeRangeOptions = (): DropdownItemProps<GlobalTimeRange>[] => {
  const { t } = useTranslation();

  const { getTimeRangeText } = useLocaleFormatter();

  const items = useMemo(() => {
    return globalTimeRangeValues.map((value: GlobalTimeRange) => {
      return {
        key: value,
        value,
        stringValue: value,
        label: getTimeRangeText(value, t),
      };
    });
  }, [t, getTimeRangeText]);

  return items;
};

interface TimeRangeProps {
  disabled?: boolean;
}

export const GlobalTimeRangeFilter = ({ disabled }: TimeRangeProps) => {
  const dispatch = useAppDispatch();

  const timeRange = useAppSelector(state => state.global.timeRange);

  const items = useTimeRangeOptions();

  const onChange = useCallback(
    (newValue: GlobalTimeRange) => {
      dispatch(setGlobalTimeFilter(newValue));
    },
    [dispatch],
  );

  return (
    <div className={styles.timeSelect}>
      <Dropdown<GlobalTimeRange>
        uid="timeRange"
        value={timeRange}
        disabled={disabled}
        items={items}
        onChange={onChange}
      />
    </div>
  );
};

export default GlobalTimeRangeFilter;
